import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {COLORS} from '../../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../../constants/typography';
import {Button} from '../../../atoms/Buttons/Button';
import {PADDING_X} from './FilterFlyout';

export interface FilterFlyoutFooterProps {
  onClose: () => void;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  primaryButtonLabel: string;
  primaryButtonDataTestId?: string;
  secondaryButtonLabel: string;
  secondaryButtonDataTestId?: string;
  hidePrimaryButton?: boolean;
}

export const FilterFlyoutFooter: FC<FilterFlyoutFooterProps> = ({
  onClose,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  primaryButtonLabel,
  primaryButtonDataTestId = 'filterPrimaryButton',
  secondaryButtonLabel,
  secondaryButtonDataTestId = 'filterSecondaryButton',
  hidePrimaryButton,
}) => (
  <Footer $addMargin={!hidePrimaryButton}>
    <SecondaryButton
      variant="secondary"
      size={hidePrimaryButton ? 'full-width' : 'fit-width'}
      data-testid={secondaryButtonDataTestId}
      onClick={onSecondaryButtonClick ?? onClose}
    >
      {secondaryButtonLabel}
    </SecondaryButton>
    {!hidePrimaryButton && (
      <PrimaryButton
        data-testid={primaryButtonDataTestId}
        onClick={onPrimaryButtonClick ?? onClose}
      >
        {primaryButtonLabel}
      </PrimaryButton>
    )}
  </Footer>
);

const Footer = styled.footer<{$addMargin?: boolean}>`
  height: 5rem;
  width: 100%;
  padding: 0 ${PADDING_X};
  border-top: 1px solid ${COLORS.Grey3};
  display: flex;
  align-items: center;
  flex-shrink: 0;
  background-color: ${COLORS.White};

  ${({$addMargin}) => $addMargin && 'gap: 1rem;'}
`;

const sharedButtonStyles = css`
  height: 3rem;
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${FONT_SIZES.px14};
`;

const PrimaryButton = styled(Button)`
  ${sharedButtonStyles}

  flex: 1;
  font-weight: ${FONT_WEIGHTS.mediumBold};
`;

const SecondaryButton = styled(Button)<{$fullWidth?: boolean}>`
  ${sharedButtonStyles}

  padding: 0 1rem;
  font-weight: ${FONT_WEIGHTS.bold};
`;
